import React, { useState } from "react";
import { DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MoldForm } from "@/pages/tech/molds/MoldForm";
import { PlateForm } from "@/pages/tech/plates/PlateForm";
import { Wrench, Layers } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface ToolingFormModalProps {
  onSuccess?: (newItem: { id: string; label: string; original?: any }) => void;
  onCancel?: () => void;
  initialType?: "DIE_CUT" | "PLATE";
  initialData?: any;
  params?: Record<string, any>;
}

export function ToolingFormModal({
  onSuccess,
  onCancel,
  initialType = "DIE_CUT",
  initialData,
  params,
}: ToolingFormModalProps) {
  const [selectedType, setSelectedType] = useState<"DIE_CUT" | "PLATE">(
    params?.type || initialType || "DIE_CUT"
  );

  const initialName = initialData?.name || initialData?.label || "";
  const productId = initialData?.productId || params?.productId;
  const customerId = initialData?.customerId || params?.customerId;

  return (
    <div className="space-y-3 py-1">
      <DialogHeader>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
          <div>
            <DialogTitle className="flex items-center gap-2">
              {selectedType === "DIE_CUT" ? (
                <Wrench className="w-5 h-5 text-indigo-600" />
              ) : (
                <Layers className="w-5 h-5 text-emerald-600" />
              )}
              Khai báo {selectedType === "DIE_CUT" ? "Khuôn bế (Die-Cut)" : "Bản kẽm CTP"}
            </DialogTitle>
            <DialogDescription className="text-xs text-slate-500 mt-0.5">
              Sử dụng canonical form chuẩn mực, đồng bộ 100% dữ liệu kỹ thuật và tự động điền trong 0.1s.
            </DialogDescription>
          </div>

          <Tabs
            value={selectedType}
            onValueChange={(val) => setSelectedType(val as "DIE_CUT" | "PLATE")}
            className="w-auto shrink-0"
          >
            <TabsList>
              <TabsTrigger value="DIE_CUT">
                Khuôn bế
              </TabsTrigger>
              <TabsTrigger value="PLATE">
                Bản kẽm
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </DialogHeader>

      <div className="w-full max-h-[78vh] overflow-y-auto px-1 py-1">
        {selectedType === "DIE_CUT" ? (
          <MoldForm
            isModal
            defaultValues={{
              name: initialName,
              productId: productId || "",
              customerId: customerId || "",
              dieLength: initialData?.dieLength || params?.dieLength || "",
              dieWidth: initialData?.dieWidth || params?.dieWidth || "",
              productLength: initialData?.productLength || params?.productLength || "",
              productWidth: initialData?.productWidth || params?.productWidth || "",
              ups: initialData?.ups || params?.ups || "",
              isShared: initialData?.isShared || false,
              ...(initialData || {}),
              ...(params || {}),
            }}
            onSuccess={onSuccess}
            onCancel={onCancel}
          />
        ) : (
          <PlateForm
            isModal
            defaultValues={{
              name: initialName,
              productId: productId || "",
              customerId: customerId || "",
              ...(initialData || {}),
              ...(params || {}),
            }}
            onSuccess={onSuccess}
            onCancel={onCancel}
          />
        )}
      </div>
    </div>
  );
}

export default ToolingFormModal;
